import { EventLogDTO } from '@/types/event/EventLogDTO';
import { PhotoStatusItemDTO } from '@/types/photostatus/PhotoStatusItemDTO';

export interface LetterStatusHistoryDTO {
  letterNumber: number;
  email: string;
  responseStatus: LetterStatusHistoryResponse;
  events?: EventLogDTO[];
  /**
   * The photos of the letter with the verdict on each, carrying previews only. The full-size bytes
   * of a photo are asked for one at a time, when the viewer opens that photo.
   */
  photos?: PhotoStatusItemDTO[];
}

export enum LetterStatusHistoryResponse {
  LETTER_INITIATIVE = 'LETTER_INITIATIVE',
  LETTER_NOT_FOUND = 'LETTER_NOT_FOUND',
  SUCCESS = 'SUCCESS',
}
